import { numberRound } from "./_utils"

/**
 * ### 社保/公积金取整
 * @param {*} value 需要转换到值
 * @param {*} type
 * 1. 四舍五入到分
 * 2. 四舍五入到角
 * 3. 四舍五入到元
 * 4. 见角进分
 * 5. 见分舍去，见角进元
 * 6. 见厘进分
 * 7. 见角舍去
 * 8. 见厘舍去
 * 9. 四舍五入到厘
 * 10. 四舍五入保留4位小数
 * @returns 转换好的value值
 */
export const SOCIAL_SECURITY_ROUND = (value, type) => {
  value = Number(value)
  if (!type) return numberRound(Number(value), 2)
  type = Number(type)
  switch (type) {
    // 四舍五入到分
    case 1:
      value = Math.round(value * 100) / 100
      break
    // 四舍五入到角
    case 2:
      value = Math.round(value * 10) / 10
      break
    // 四舍五入到元
    case 3:
      value = Math.round(value)
      break
    // 见角进分
    case 4:
      value = Math.ceil(value * 10) / 10
      break
    // 见分舍去，见角进元
    case 5:
      value = Math.ceil(value)
      break
    // 见厘进分
    case 6:
      value = Math.ceil(value * 100) / 100
      break
    // 见角舍去
    case 7:
      value = Math.floor(value)
      break
    // 见厘舍去
    case 8:
      value = Math.floor(value * 100) / 100
      break
    // 四舍五入到厘
    case 9:
      value = Math.round(value * 1000) / 1000
      break
    // 四舍五入保留4位小数
    case 10:
      value = Math.round(value * 10000) / 10000
      break
    default:
      value = numberRound(Number(value), 2)
      break
  }
  return value
}
